import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { SliderControl } from '../../components/controls/SliderControl';
import { SelectControl } from '../../components/controls/SelectControl';

import { fetchGuaranteedIncome, fetchSpendingSourcesGuaranteedIncome } from '../../actions/wealthManagementActions';

export class GuaranteedIncomeSidebar extends Component {
  constructor(props) {
    super(props);
  }

  onChange = (type, evt) => {
    this.props.onChange(type, evt.detail.value);
  };

  render() {
    return (
      <div>
        <SliderControl
          minLabel="0%"
          maxLabel="50%"
          value={this.props.diaConversion}
          spec={{
            field_type: 'range',
            min: 0,
            max: 0.5,
            step_size: 0.01,
            _default: this.props.diaConversion,
          }}
          valueFormatter={val => `${(val * 100).toFixed(0)}% Guaranteed Income`}
          onChange={e => this.onChange('diaConversion', e)}
          onInput={e => this.onChange('diaConversion', e)}
        />
      </div>
    );
  }
}

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(GuaranteedIncomeSidebar);
